import type {
  AssessmentClientActionType,
  IAssessmentClientItem,
  IAssessmentClientState,
} from '../types';
import {
  reduceActiveAssessmentClientState,
  reduceSubmittingAssessmentClientState,
} from './reducer';

export function reduceAssessmentClientState<TItem extends IAssessmentClientItem, TResult>(
  state: IAssessmentClientState<TItem, TResult>,
  action: AssessmentClientActionType<TItem, TResult>,
): IAssessmentClientState<TItem, TResult> {
  if (state.phase === 'completed') {
    return state;
  }
  if (action.type === 'result_received') {
    return {
      ...state,
      answeredCount: state.totalCount,
      currentItem: null,
      error: null,
      phase: 'completed',
      result: action.result,
    };
  }
  if (action.type === 'session_started') {
    return {
      ...state,
      attemptId: action.attemptId,
      currentItem: action.item,
      currentToken: action.token,
      error: null,
      phase: 'active',
    };
  }
  if (state.phase === 'active') {
    return reduceActiveAssessmentClientState(state, action);
  }
  if (state.phase === 'submitting') {
    return reduceSubmittingAssessmentClientState(state, action);
  }
  return state;
}
